import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Sim } from '../models/sim';
import { SimUsage } from '../models/sim-usage';
import { map } from 'rxjs/operators';
import { Operator } from '../models/operator';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SimDataService {

  constructor(private http: HttpClient, private datePipe: DatePipe) { }

  getAllSims = (projectId: number) :  Observable<Sim[]> => {
    return this.http.get<Sim[]>(`${environment.api.baseUrl}/${environment.api.endpoints.sim.simList}?projectId=${projectId}`)
    .pipe(map( (sims: Sim[]) => {
      return sims.map(sim => {
        return {
          ...sim,
          lastSeen: this.datePipe.transform(sim.lastSeen) || '',
          simConfig: {
            ...sim.simConfig,
            startDate: this.datePipe.transform(sim.simConfig.startDate) || '',
          }
        }
      })
    }));
  }

  getAllSimsUsage = (projectId: number) :  Observable<SimUsage[]> => {
    return this.http.get<SimUsage[]>(`${environment.api.baseUrl}/${environment.api.endpoints.sim.simList}/usage?projectId=${projectId}`);
  }

  getSimsByTrain = (projectId: number, trainId: number) :  Observable<Sim[]> => {
    return this.http.get<Sim[]>(`${environment.api.baseUrl}/${environment.api.endpoints.sim.simTrain}/${trainId}?projectId=${projectId}`);
  }

  getSimUsage = (projectId: number, iccid: string, from: any, to: any) : Observable<SimUsage> => {
    const params = new HttpParams()
    .set('projectId', projectId.toString())
    .set('from', from)
    .set('to', to);
 
    return this.http.get<SimUsage>(`${environment.api.baseUrl}/${environment.api.endpoints.sim.simUsage}/${iccid}`, { params });
  }

  getSim = (simId: number, projectId: number): Promise<Sim> => {
    return this.http.get<Sim>(`${environment.api.baseUrl}/${environment.api.endpoints.sim.simList}/${simId}?projectId=${projectId}`).toPromise();
  }

  createSim = (sim: Sim, projectId: number) => {
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.sim.simList}?projectId=${projectId}`, sim).toPromise();
  }

  updateSim = (sim: Sim, projectId: number) => {
    return this.http.put(`${environment.api.baseUrl}/${environment.api.endpoints.sim.simList}/${sim.id}?projectId=${projectId}`, sim).toPromise();
  }
  
  deleteSim = (simIccid: string, projectId: number) => {
    return this.http.delete(`${environment.api.baseUrl}/${environment.api.endpoints.sim.simList}/${simIccid}?projectId=${projectId}`).toPromise();
  }

  getAllOperators = (projectId: number) :  Observable<Operator[]> => {
    return this.http.get<Operator[]>(`${environment.api.baseUrl}/${environment.api.endpoints.sim.operators}?projectId=${projectId}`).pipe(
      map(operators => operators.map(operator => {
        operator.code = `${operator.mcc}${operator.mnc}`;
        return operator;
      }))
    );
  }

  exportSimDataPerPeriod = (projectId: number, dateFrom: string, dateTo: string, token) => {
    const url = `${environment.api.baseUrl}/${environment.api.endpoints.sim.exportSim}?projectId=${projectId}&from=${dateFrom}&to=${dateTo}&token=${token}`;
    window.open(url.replace(/[+]/g, '%2B'));
  }
}
